import React from 'react'
import styled from 'styled-components'
import { Icon, Form, Container, Fonts, Button, BtnBack } from 'components/base-ui'
import { useTranslation } from 'react-i18next'

const TrueWallet = ({
  isError,
  handlePlaceOrder,
  isRequestPlaceOder,
  trueWalletPhone,
  setTrueWalletPhone,
  setIsNotValidTrueWalletPhone,
  onClickBack,
}) => {
  const { t } = useTranslation()

  return (
    <TrueWalletContainer id="true-wallet-page">
      <Header>
        <BtnBack onClick={onClickBack} enableFastClick={false} />
      </Header>
      <Content>
        <TrueIcon
          src={`${process.env.PUBLIC_URL}/assets/payment/icon-true-money-wallet.png`}
          srcSet={`${process.env.PUBLIC_URL}/assets/payment/icon-true-money-wallet.png 1x, ${process.env.PUBLIC_URL}/assets/payment/icon-true-money-wallet@2x.png 2x, ${process.env.PUBLIC_URL}/assets/payment/icon-true-money-wallet@3x.png 3x`}
        />
        <Fonts.H2>กรุณากรอกเบอร์โทรศัพท์ที่ผูกไว้กับ True Money</Fonts.H2>
        <InputWraooer>
          <Form.InputManual
            id="phoneTxt"
            data-testid="phoneTxt"
            type="tel"
            md2
            placeholderFloat={t('tel')}
            placeholder="089-123-4567"
            showBothPlaceholder
            required
            hideTextError
            value={trueWalletPhone}
            onChange={(e) => {
              if (isError) {
                setIsNotValidTrueWalletPhone(false)
              }
              setTrueWalletPhone(e.target.value)
            }}
            disabled={isRequestPlaceOder}
            error={isError}
          />
        </InputWraooer>
        {isError && (
          <ErrorMsg>
            <Icon name="warning-triangle" />
            <Fonts.SmallTitleBold>คุณกรอกหมายเลขโทรศัพท์ไม่ถูกต้อง</Fonts.SmallTitleBold>
          </ErrorMsg>
        )}
        <Button
          id="otpBtn"
          data-testid="otpBtn"
          float
          md2
          isProcessing={isRequestPlaceOder}
          disabled={isRequestPlaceOder}
          onClick={handlePlaceOrder}
          enableFastClick={false}
        >
          รับ OTP
        </Button>
      </Content>
    </TrueWalletContainer>
  )
}

export default TrueWallet

const TrueWalletContainer = styled(Container)`
  padding: 30px ${({ theme }) => theme.spacing['2XL']};
`

const Header = styled.div``

const Content = styled.div`
  padding: 0 22px;
`

const TrueIcon = styled.img`
  display: block;
  margin: 0 auto;
  margin-bottom: 15px;
`

const InputWraooer = styled.div`
  margin-top: ${({ theme }) => theme.spacing.S};
  margin-bottom: 13px;
`

const ErrorMsg = styled.div`
  margin-top: -5px;
  margin-bottom: ${({ theme }) => theme.spacing.M};
  display: flex;
  align-items: center;

  i {
    margin-right: ${({ theme }) => theme.spacing.S};
    color: ${({ theme }) => theme.colors.errorLight};
  }
`
